import { render, staticRenderFns } from "./larkList.vue?vue&type=template&id=5041b906&scoped=true"
import script from "./larkList.vue?vue&type=script&lang=js"
export * from "./larkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041b906",
  null
  
)

export default component.exports